import { LocalStorageService } from "./local-storage.service";
import { SessionService } from "./session.service";

//will be removed after test
// const testToken = "";

/**
 * Where the token a sign up is given lives. With the new billing flow on,
 * /Account/confirmEmail answers with a token, and the billing calls that finish
 * the sign up — picking a plan, checking a promo code — need a real one. It is
 * not a sign in: it sits in the tab's session beside the rest of the
 * registration (see pages/auth/register/registrationSession.js), the app keeps
 * treating the tab as signed out, and only the billing client ever sends it.
 */
export const SIGN_UP_TOKEN_KEY = "signUpToken";

/**
 * Why a session was ended for the user, which the login page says
 * (`/auth/login?reason=…`, pages/auth/login/Login.jsx). SUBSCRIPTION: with the
 * new billing flow off, the refresh refused the organization's subscription,
 * and signing in again is what shows what it needs. ORGANIZATION_LOCKED: the
 * only organization of somebody who can't manage its billing was held at
 * billing_only while they were in it (Routes.js).
 */
export const LogoutReason = Object.freeze({
   SUBSCRIPTION: "subscription",
   ORGANIZATION_LOCKED: "organization-locked"
});

const AuthService = {
   getAccessToken() {
      return LocalStorageService.getItem("atoken") || null; // will be null after test
   },

   getRefreshToken() {
      return LocalStorageService.getItem("rtoken") || null; // will be null after test;
   },

   /** The token a sign up in this tab was given — see SIGN_UP_TOKEN_KEY. */
   getSignUpToken() {
      return SessionService.getItem(SIGN_UP_TOKEN_KEY) || null;
   },

   setSignUpToken(token) {
      if (token) {
         SessionService.setItem(SIGN_UP_TOKEN_KEY, token);
      } else {
         SessionService.removeItem(SIGN_UP_TOKEN_KEY);
      }
   },

   setTokens(aToken, rToken) {
      LocalStorageService.setItem("atoken", aToken);
      LocalStorageService.setItem("rtoken", rToken);
   },

   getTokenExpirationTime() {
      LocalStorageService.getItem("tokenExpire");
   },

   isAuthenticated() {
      const token = this.getAccessToken();
      return !!token;
   },

   isAuthorized(allowedRoles) {
      const user = this.getUser();
      const roles = JSON.parse(localStorage.getItem("roles"));

      if (!roles) return false;
      let userRoles;

      if (user !== null) {
         userRoles = roles?.map((role) => {
            return role.id;
         });
      } else {
         userRoles = ["-1"];
      }

      const contains = allowedRoles.some((element) => {
         return userRoles.indexOf(element) !== -1;
      });
      return contains;
   },

   setUser(model) {
      LocalStorageService.setItem("user", model);
   },

   getUser() {
      if (this.isAuthenticated()) {
         return LocalStorageService.getItem("user");
      } else {
         return null;
      }
   },
   getOrganizationId() {
      return LocalStorageService.getItem("organizationId");
   },

   // `reason`, one of LogoutReason, when the app ends the session itself.
   // Anything else is ignored: logout is also handed straight to onClick, which
   // passes it the click.
   logout(reason) {
      LocalStorageService.removeItem("user");
      LocalStorageService.removeItem("roles");
      LocalStorageService.removeItem("atoken");
      LocalStorageService.removeItem("rtoken");
      LocalStorageService.removeItem("tokenExpire");
      LocalStorageService.removeItem("organizationId");
      LocalStorageService.removeItem("organizationName");
      // Each organization's billing status (components/Billing/billingStore.js).
      LocalStorageService.removeItem("billingStatuses");
      // Whether the sidebar is collapsed (_metronic/layout/components/AdminLayout.js).
      LocalStorageService.removeItem("asideMinimized");
      // What the Help Center remembers, "helpCenter.<name>.<userId>"
      // (components/HelpCenter/helpStorage.js).
      Object.keys(localStorage)
         .filter((key) => key.startsWith("helpCenter."))
         .forEach((key) => LocalStorageService.removeItem(key));
      SessionService.clear();
      window.location.href = Object.values(LogoutReason).includes(reason)
         ? `/auth/login?reason=${reason}`
         : "/auth/login";
   }
};

export default AuthService;
